export const LISTEN_ON_SAVE_BUSINESS_PROFILE =
  "LISTEN_ON_SAVE_BUSINESS_PROFILE";

export const listenOnSaveBusinessProfile = (payload) => {
  return {
    type: LISTEN_ON_SAVE_BUSINESS_PROFILE,
    payload,
  };
};
